<!--
  Created 01.11.2023
  Transport cards component for the proposal show page.
  This component showcases a range of transportation entries on the proposal page.
-->
<template>
  <div class="grid-cols grid gap-8 lg:grid-cols-2">
    <TransportCard
      v-for="(item, index) in transport.filter((filterItem) => (filterItem.heading || filterItem.outbound.date) || contentEditable)"
      :id="item.id"
      :key="item.id"
      :index="index"
      :content-editable="contentEditable"
      :heading="item.heading"
      :outbound="item.outbound"
      :inbound="item.inbound"
      @remove-item="(index) => $emit('removeItem', index)" />
    <div
      v-if="contentEditable"
      class="flex cursor-pointer flex-col overflow-hidden rounded-md border-2 border-dotted border-aqua-150 opacity-25 hover:opacity-75"
      @click="$emit('addItem')">
      <h1 class="bg-aqua-150 p-4 text-center text-sm font-medium text-gray-800 md:text-lg">
        Click to add new transport
      </h1>
      <div class="flex grow flex-col divide-aqua-150 bg-white max-md:divide-y-2 md:flex-row md:max-lg:divide-x-2 lg:max-xl:flex-col lg:max-xl:divide-y-2 xl:divide-x-2">
        <section class="basis-1/2 p-4 text-xs text-gray-700 md:text-sm">
          <h2 class="">
            Outbound (example)
          </h2>
          <p class="text-base font-medium text-gray-800 md:text-lg">
            Thursday 01.01.2024
          </p>
          <p class="mt-1">
            Departure domestic airport 08:00
          </p>
          <p>
            Arrival international airport 08:50
          </p>
        </section>
        <section class="basis-1/2 p-4 text-xs text-gray-700 md:text-sm">
          <h2 class="">
            Inbound
          </h2>
          <p class="text-base font-medium text-gray-800 md:text-lg">
            Fill in inbound date
          </p>
          <p class="mt-1">
            Fill in departure text
          </p>
          <p>
            Fill in arrival text
          </p>
        </section>
      </div>
    </div>
  </div>
</template>
<script setup>
/* local */
import TransportCard from '@/Pages/Proposal/Components/TransportCard.vue';

/* *********************************************************************
 * Component declarations
 * ****************************************************************** */

defineEmits(['addItem', 'removeItem']);

const props = defineProps({
  contentEditable: {
    type: Boolean,
    default: false,
  },
  transport: {
    type: Array,
    required: true,
    default: () => [],
    validator(value) {
      return value.every((item) => item.id && item.heading && item.outbound && item.inbound);
    },
  },
});

</script>
